<template>
  <v-container px-8>
    <h1>Update 16 Jun 2020</h1>
    De volgende zaken hebben dispensatie aangevraagd:
    <GeregistreerdeZaken />
    <h1>Update 08 Jun 2020</h1>
    <p class="md4">
      De bewegingsvrijheid van mensen wordt beperkt vanaf maandag 8 juni tot en
      met 21 juni 2020. De winkels zijn alleen van 7.00 tot 14.00 uur open,
      behalve op woensdag en zondag. Mensen mogen alleen in urgente gevallen op
      straat. Zie
      https://covid-19.sr/nadere-uitleg-verscherpte-lockdown-maatregelen/ voor
      meer info.
    </p>
    <p class="md4">
      从6月8日（周一）直到2020年6月21日限制人们的行动自由。商店仅在上午7点至下午2点开放。星期三和星期日除外。仅在紧急情况下允许人们出门。
      欲获得更多信息请咨询
      https://covid-19.sr/nadere-uitleg-verscherpte-lockdown-maatregelen/。
    </p>
    <v-dialog v-model="dialog" width="680">
      <template v-slot:activator="{ on }">
        <v-btn color="red lighten-2" dark v-on="on">
          Dispensatie aanvraag formulier (出门准许证申请表)
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Dispensatie aanvraag formulier
        </v-card-title>

        <v-card-text>
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSfZNrgFoYGse1JcdXw_B62mUSlDpeAqko72iwnb0FZ0i0385A/viewform?embedded=true"
            width="640"
            height="2300"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
          >
            Loading…
          </iframe>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// import Announcements from "@/components/Announcements";
import GeregistreerdeZaken from "../components/GeregistreerdeZaken";
export default {
  name: "HomePage",
  components: { GeregistreerdeZaken },
  // components: {Announcements},
  data() {
    return {};
  }
};
</script>

<style scoped>
ul {
  list-style-type: none;
}
</style>
